module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "downbtn"
  }, [_c('div', {
    staticClass: "anzhuo",
    on: {
      "click": _vm.downApp
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ipod",
    on: {
      "click": _vm.downApp
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ef5f853","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/newagent-regsiter-user/download-page/index.vue
// module id = 358
// module chunks = 0